export enum InstanceType {
    Dungeon = 1,
    Raid = 2,
    Pvp = 3,
    Scenario = 5,
}
